// services/api/companyApi.js
import axiosInstance from "utils/axiosInstance";

const companyApi = {
  /**
   * Fetches all companies. A super_admin gets all, a regular admin gets their own.
   * @returns {Promise<Array>} A promise that resolves to an array of company objects.
   */
  getCompanies: async () => {
    // The backend will automatically scope this based on the user's token.
    // A super_admin will get all companies.
    // A regular admin will only get the one they belong to.
    const response = await axiosInstance.get("/company/getall");
    return response.data || [];
  },

  /**
   * Creates a new company (Super Admin only).
   * @param {Object} companyData - The company data to create.
   * @returns {Promise<Object>} A promise that resolves to the created company object.
   */
  createCompany: async (companyData) => {
    // This endpoint should be protected by the get_current_super_admin dependency
    const response = await axiosInstance.post("/company/create", companyData);
    return response.data;
  },

  /**
   * Updates an existing company (Super Admin or regular Admin for their own company).
   * @param {string} companyId - The ID of the company to update.
   * @param {Object} companyData - The updated company data.
   * @returns {Promise<Object>} A promise that resolves to the updated company object.
   */
  updateCompany: async (companyId, companyData) => {
    // This endpoint should be protected by get_current_admin
    const response = await axiosInstance.put(`/company/update/${companyId}`, companyData);
    return response.data;
  },

  /**
   * Deletes a company (Super Admin only).
   * @param {string} companyId - The ID of the company to delete.
   * @returns {Promise<Object>} A promise that resolves to the response data.
   */
  deleteCompany: async (companyId) => {
    // This endpoint should be protected by get_current_super_admin
    const response = await axiosInstance.delete(`/company/delete/${companyId}`);
    return response.data;
  },
};

export default companyApi;